<template>
  <div class="app">
    <Card dis-hover>
      <Form ref="queryForm" :label-width="70" label-position="left" inline>

        <FormItem label="关键字：">
          <Input type="text" placeholder="请输入" v-model="form.keyword" style="width: 180px"></Input>
        </FormItem>

        <FormItem label="状态：">
          <Select v-model="form.status" placeholder="请选择状态" style="width: 180px" clearable>
            <Option v-for="item in statusList" :key="item.value" :value="item.value">{{ item.name }}</Option>
          </Select>
        </FormItem>

        <Button icon="ios-search" type="primary" size="default" @click="getData" class="toolbar-btn">查询</Button>
        <Button icon="md-refresh" type="default" size="default" @click="reset" class="toolbar-btn">重置</Button>

      </Form>
      <div class="table_body">
        <Table ref="table" border :loading="loading" :columns="columns" :no-data-text="NoDatas" :data="tableBody_item">
          <template slot-scope="{ row }" slot="action">
            <Button v-if="row.isShow_创建人员" type="primary" size="small" style="margin-right: 5px;" @click="openCreateUser(row)">创建人员</Button>
            <Button v-if="row.isShow_拒绝" type="error" size="small" @click="rejectRegistration(row)">拒绝</Button>
          </template>
        </Table>
        <div style="margin-top: 10px;">
          <Page show-sizer show-elevator show-total :current="current" :total="totalCount" @on-change="pageChange" @on-page-size-change="pagesizeChange"></Page>
        </div>
      </div>
    </Card>

    <!-- 拒绝理由弹窗 -->
    <Modal v-model="rejectModal" title="拒绝注册申请" :mask-closable="false" @on-ok="confirmReject" @on-cancel="cancelReject">
      <Form ref="rejectForm" :model="rejectFormData" :rules="rejectRules" :label-width="100">
        <FormItem label="拒绝理由：" prop="remark">
          <Input v-model="rejectFormData.remark" type="textarea" :rows="4" placeholder="请输入拒绝理由"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="cancelReject">取消</Button>
        <Button type="primary" :loading="createUserLoading" @click="confirmReject">确认</Button>
      </div>
    </Modal>

    <!-- 创建人员弹窗 -->
    <Modal v-model="createUserModal" title="创建人员" width="70%" :mask-closable="false">
      <Form ref="createUserForm" :model="createUserData" :rules="createUserRules" :label-width="120">
        <Tabs value="detail">
          <TabPane label="用户信息" name="detail">
            <Divider orientation="left" size="small"><a href="#">账号信息</a></Divider>
            <Row>
              <Col span="6">
              <FormItem label="登录账号" prop="userName">
                <Input v-model="createUserData.userName" :minlength="2"></Input>
              </FormItem>
              </Col>
              <Col span="6">
              <FormItem label="密码" prop="password">
                <Input v-model="createUserData.password" :maxlength="32" type="password"></Input>
              </FormItem>
              </Col>
              <Col span="6">
              <FormItem label="确认密码" prop="confirmPassword">
                <Input v-model="createUserData.confirmPassword" :maxlength="32" type="password"></Input>
              </FormItem>
              </Col>
              <Col span="6">
              <FormItem>
                <Checkbox v-model="createUserData.isActive">是否启用</Checkbox>
              </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
              <FormItem label="所属部门" prop="organizationUnitIds" v-if="createUserModal">
                <selectTree v-model="createUserData.organizationUnitIds" :multiple="true" :treeData="treeData" @on-select-change="selectChange" @on-remove="removeRoot" :showQuery="false"></selectTree>
              </FormItem>
              </Col>
            </Row>
            <Divider orientation="left" size="small"><a href="#">个人信息</a></Divider>
            <Row>
              <Col span="7">
              <FormItem label="姓名" prop="name">
                <Input v-model="createUserData.name"></Input>
              </FormItem>
              </Col>
              <Col span="7">
              <FormItem label="工号" prop="number">
                <Input v-model="createUserData.number"></Input>
              </FormItem>
              </Col>
              <Col span="7">
              <FormItem label="岗位" prop="post">
                <Select v-model="createUserData.post" :transfer="true">
                  <Option value="">---</Option>
                  <Option v-for="item in postOptions" :key="item.value" :value="item.value">{{ item.text }}</Option>
                </Select>
              </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="7">
              <FormItem label="事业部" prop="causeDepartment">
                <Input v-model="createUserData.causeDepartment"></Input>
              </FormItem>
              </Col>
              <Col span="7">
              <FormItem label="邮箱地址" prop="emailAddress">
                <Input v-model="createUserData.emailAddress" type="email"></Input>
              </FormItem>
              </Col>
              <Col span="7">
              <FormItem label="手机号码" prop="phoneNumber">
                <Input v-model="createUserData.phoneNumber"></Input>
              </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="7">
              <FormItem label="入职时间" prop="joinedCompanyDate">
                <DatePicker type="date" v-model="createUserData.joinedCompanyDate" :transfer="true" style="width: 100%"></DatePicker>
              </FormItem>
              </Col>
              <Col span="7">
              <FormItem label="职务" prop="job">
                <Input v-model="createUserData.job"></Input>
              </FormItem>
              </Col>
            </Row>
          </TabPane>
          <TabPane label="用户角色" name="roles">
            <CheckboxGroup v-model="createUserData.roleNames">
              <Checkbox v-for="role in roleList" :key="role.id" :label="role.name">
                <span>{{ role.displayName }}</span>
              </Checkbox>
            </CheckboxGroup>
          </TabPane>
        </Tabs>
      </Form>
      <div slot="footer">
        <Button @click="cancelCreateUser">取消</Button>
        <Button type="primary" :loading="createUserLoading" @click="confirmCreateUser">确认</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import moment from 'moment'
import selectTree from '@/components/selectTree/selectTree.vue'

export default {
  name: 'userRegistration',
  props: {},
  components: { selectTree },
  filters: {
    formData(val) {
      return moment(val).format('YYYY-MM-DD HH:mm')
    },
  },
  data() {
    return {
      totalCount: 0, // 总共多少条
      current: 1, // 当前第几页
      form: {
        keyword: '',
        status: null, // 默认状态为1
        SkipCount: 0, // 从第几条开始
        MaxResultCount: 10, // 一页多少条
      },
      NoDatas: '暂无数据',
      loading: false,
      columns: [],
      tableBody_item: [],
      statusList: [], // 状态下拉框数据
      rejectModal: false, // 拒绝弹窗
      rejectFormData: {
        remark: '',
      },
      rejectRules: {
        remark: [{ required: true, message: '请输入拒绝理由', trigger: 'blur' }],
      },
      currentRejectRow: null, // 当前拒绝的行数据
      // 创建人员相关
      createUserModal: false,
      createUserLoading: false,
      currentRegistrationId: null,
      treeData: [], // 部门树
      roleList: [], // 角色列表
      postOptions: [], // 岗位选项
      createUserData: {
        userName: '',
        name: '',
        surname: '',
        emailAddress: '',
        isActive: true,
        roleNames: [],
        password: '',
        confirmPassword: '',
        job: '',
        weChatAccount: '',
        phoneNumber: '',
        companyName: '',
        city: '',
        isOutSide: false,
        number: '',
        causeDepartment: '',
        post: '',
        joinedCompanyDate: '',
        workStatus: 0,
        organizationUnitIds: [],
      },
      createUserRules: {
        userName: [{ required: true, message: '必填项不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '必填项不能为空', trigger: 'blur' }],
        password: [
          { required: true, message: '必填项不能为空', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              const reg =
                /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\\W_!@#$%^&*`~()-+=]+$)(?![0-9\\W_!@#$%^&*`~()-+=]+$)(?![a-zA-Z0-9]+$)(?![a-zA-Z\\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9\\W_!@#$%^&*`~()-+=]+$)(?![0-9A-Z\\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\\W_!@#$%^&*`~()-+=]{8,}$/
              if (!reg.test(value)) {
                callback(new Error('密码要求长度大于8位，且包含大写字母、小写字母、数字、特殊符号'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        confirmPassword: [
          { required: true, message: '必填项不能为空', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.createUserData.password) {
                callback(new Error('两次密码不一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        emailAddress: [
          { required: true, message: '必填项不能为空', trigger: 'blur' },
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' },
        ],
        number: [{ required: true, message: '必填项不能为空', trigger: 'blur' }],
        post: [{ required: true, message: '必选项不能为空', trigger: 'change', type: 'number' }],
        organizationUnitIds: [
          {
            validator: (rule, value, callback) => {
              if (!value || (Array.isArray(value) && value.length === 0)) {
                callback(new Error('必填项不能为空'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
        joinedCompanyDate: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value === '' || value === undefined || value === null) {
                callback(new Error('日期不能为空'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getInitData() // 获取初始化数据
    this.getColumns() // 列表数据初始化
    this.getData() // 获取列表数据
  },
  methods: {
    // 页数
    pageChange(size) {
      this.current = size
      this.form.SkipCount = (size - 1) * this.form.MaxResultCount
      this.getData()
    },
    // 每页最大条数
    pagesizeChange(size) {
      this.form.MaxResultCount = size
      this.getData()
    },
    // 重置
    reset() {
      this.form.keyword = ''
      this.form.status = 1
      this.form.SkipCount = 0
      this.current = 1
      this.getData()
    },
    // 获取列表数据
    async getData() {
      this.loading = true
      try {
        let findData = await this.$Ajax.get('/UserRegistration/QueryDto', {
          params: this.form,
        })
        this.tableBody_item = findData.data.result.items
        this.totalCount = findData.data.result.totalCount
      } catch (error) {
        console.error('获取数据失败:', error)
      }
      this.loading = false
    },
    // 获取初始化数据（状态下拉框）
    async getInitData() {
      try {
        let initData = await this.$Ajax.get('/UserRegistration/GetInitData')
        if (initData.data.result) {
          this.statusList = initData.data.result.statusList || []
        }
      } catch (error) {
        console.error('获取初始化数据失败:', error)
        // 设置默认状态列表
        this.statusList = [
          { value: 0, name: '待处理' },
          { value: 1, name: '已处理' },
          { value: 2, name: '已拒绝' },
        ]
      }
    },
    // 格式化日期时间
    formatDateTime(dateTime) {
      if (!dateTime) return '-'
      return moment(dateTime).format('YYYY-MM-DD HH:mm')
    },
    // 打开拒绝弹窗
    rejectRegistration(row) {
      this.currentRejectRow = row
      this.rejectFormData.remark = ''
      this.rejectModal = true
    },
    // 确认拒绝
    async confirmReject() {
      this.$refs.rejectForm.validate(async (valid) => {
        if (!valid) return
        try {
          await this.$Ajax.post(
            `/UserRegistration/RejectRegistration?id=${
              this.currentRejectRow.id
            }&remark=${encodeURIComponent(this.rejectFormData.remark)}`
          )
          this.$Message.success('已拒绝该注册申请')
          this.rejectModal = false
          this.$refs.rejectForm.resetFields()
          this.getData()
        } catch (error) {
          console.error('拒绝失败:', error)
        }
      })
    },
    // 取消拒绝
    cancelReject() {
      this.rejectModal = false
      this.$refs.rejectForm.resetFields()
      this.currentRejectRow = null
    },
    // 打开创建人员弹窗
    async openCreateUser(row) {
      this.currentRegistrationId = row.id
      try {
        // 获取角色列表
        const roleRes = await this.$Ajax.get('/api/services/app/Role/GetRoles')
        this.roleList = roleRes.data.result.items || []

        // 获取岗位选项
        const initRes = await this.$Ajax.get('/api/services/app/User/GetUserFormInitData')
        this.postOptions = initRes.data.result.postOptions || []

        // 获取注册详情
        const detailRes = await this.$Ajax.get(
          `/UserRegistration/GetRegistrationForProcess?id=${row.id}`
        )
        if (detailRes.data.result) {
          const detail = detailRes.data.result
          this.createUserData = {
            userName: detail.userName || '',
            name: detail.name || '',
            surname: detail.surname || '',
            emailAddress: detail.emailAddress || '',
            isActive: detail.isActive !== undefined ? detail.isActive : true,
            roleNames: detail.roleNames || [],
            password: detail.password || '',
            confirmPassword: detail.password || '',
            job: detail.job || '',
            weChatAccount: detail.weChatAccount || '',
            phoneNumber: detail.phoneNumber || '',
            companyName: detail.companyName || '',
            city: detail.city || '',
            isOutSide: detail.isOutSide || false,
            number: detail.number || '',
            causeDepartment: detail.causeDepartment || '',
            post: detail.post || '',
            joinedCompanyDate: detail.joinedCompanyDate || '',
            workStatus: detail.workStatus,
            organizationUnitIds: detail.organizationUnitIds || [],
          }
        }

        // 先打开弹窗，让 selectTree 组件挂载
        this.createUserModal = true

        // 等待 DOM 更新后再设置 treeData，触发 selectTree 的 watch 重新初始化选中状态
        this.$nextTick(async () => {
          const treeRes = await this.$Ajax.get(
            '/api/services/app/OrganizationUnit/GetOrganizationUnitTree'
          )
          this.editeTreeValue(treeRes.data.result)
          this.treeData = treeRes.data.result
        })
      } catch (error) {
        console.error('获取创建人员信息失败:', error)
      }
    },
    // 处理部门树数据
    editeTreeValue(data) {
      for (let i = 0; i < data.length; i++) {
        data[i].title = data[i].displayName
        data[i].value = data[i].id
        if (data[i].children) {
          if (data[i].children.length > 0) {
            data[i].expand = true
          }
          this.editeTreeValue(data[i].children)
        }
      }
    },
    // 部门选择变化
    selectChange(data) {
      this.createUserData.organizationUnitIds = data
    },
    // 移除部门
    removeRoot(data) {
      this.createUserData.organizationUnitIds = data
    },
    // 确认创建人员
    confirmCreateUser() {
      this.$refs.createUserForm.validate(async (valid) => {
        if (valid) {
          this.createUserLoading = true
          try {
            // organizationUnitIds 已经是数组格式
            const orgIds = Array.isArray(this.createUserData.organizationUnitIds)
              ? this.createUserData.organizationUnitIds.map((id) => Number(id))
              : []

            const submitData = {
              registrationId: this.currentRegistrationId,
              createUserDto: {
                userName: this.createUserData.userName,
                name: this.createUserData.name,
                surname: this.createUserData.surname,
                emailAddress: this.createUserData.emailAddress,
                isActive: this.createUserData.isActive,
                roleNames: this.createUserData.roleNames,
                password: this.createUserData.password,
                job: this.createUserData.job,
                weChatAccount: this.createUserData.weChatAccount,
                phoneNumber: this.createUserData.phoneNumber,
                companyName: this.createUserData.companyName,
                city: this.createUserData.city,
                isOutSide: this.createUserData.isOutSide,
                number: this.createUserData.number,
                causeDepartment: this.createUserData.causeDepartment,
                post: this.createUserData.post,
                joinedCompanyDate: this.createUserData.joinedCompanyDate,
                workStatus: this.createUserData.workStatus,
                organizationUnitIds: orgIds,
              },
            }

            await this.$Ajax.post('/UserRegistration/ProcessRegistration', submitData)
            this.$Message.success('创建人员成功')
            this.createUserModal = false
            this.getData()
          } catch (error) {
            console.error('创建人员失败:', error)
          }
          this.createUserLoading = false
        }
      })
    },
    // 取消创建人员
    cancelCreateUser() {
      this.createUserModal = false
      this.$refs.createUserForm.resetFields()
    },
    // table 列
    getColumns() {
      this.columns = [
        {
          title: '用户名（登录账号）',
          key: 'userName',
          width: 140,
        },
        {
          title: '姓名',
          key: 'name',
          width: 100,
        },
        {
          title: '联系手机',
          key: 'phoneNumber',
          width: 120,
        },
        {
          title: '所属部门',
          key: 'organizationUnitNames',
          minWidth: 150,
          render: (h, params) => {
            const names = params.row.organizationUnitNames
            if (names && names.length > 0) {
              return h('span', names.join('、'))
            }
            return h('span', '-')
          },
        },
        {
          title: '申请开通的模块',
          key: 'moduleList',
          minWidth: 150,
          render: (h, params) => {
            const modules = params.row.moduleList
            if (modules && modules.length > 0) {
              return h('span', modules.join('、'))
            }
            return h('span', '-')
          },
        },
        {
          title: '状态',
          key: 'statusText',
          width: 90,
          align: 'center',
          render: (h, params) => {
            const status = params.row.status
            let color = ''
            switch (status) {
              case 0:
                color = '#ff9900' // 待处理 - 橙色
                break
              case 1:
                color = '#19be6b' // 已处理 - 绿色
                break
              case 2:
                color = '#ed4014' // 已拒绝 - 红色
                break
              default:
                color = '#515a6e'
            }
            return h(
              'span',
              {
                style: {
                  color: color,
                  fontWeight: 'bold',
                },
              },
              params.row.statusText || '-'
            )
          },
        },
        {
          title: '处理备注',
          key: 'processRemark',
          minWidth: 120,
          render: (h, params) => {
            return h('span', params.row.processRemark || '-')
          },
        },
        {
          title: '处理时间',
          key: 'processTime',
          width: 150,
          render: (h, params) => {
            return h('span', this.formatDateTime(params.row.processTime))
          },
        },
        {
          title: '处理人',
          key: 'processUserName',
          width: 100,
          render: (h, params) => {
            return h('span', params.row.processUserName || '-')
          },
        },
        {
          title: '创建的用户名',
          key: 'createdUserName',
          width: 120,
          render: (h, params) => {
            return h('span', params.row.createdUserName || '-')
          },
        },
        {
          title: '创建时间',
          key: 'creationTime',
          width: 150,
          render: (h, params) => {
            return h('span', this.formatDateTime(params.row.creationTime))
          },
        },
        {
          title: '操作',
          key: 'action',
          slot: 'action',
          width: 180,
          fixed: 'right',
        },
      ]
    },
  },
}
</script>

<style lang="less" scoped>
.toolbar-btn {
  margin-right: 8px;
}

.table_body {
  margin-top: 15px;
}
</style>
